// libs
import React, {useEffect, useState} from 'react';
import { useTranslation } from "react-i18next";

// components
import ManageCardForm from "./ManageCardForm";
import BlockCardPanel from "./BlockCardPanel";
import ReplaceCardPanel from "./ReplaceCardPanel";
import SaveCardPanel from "./SaveCardPanel";
import axios from "../../../../../axios-defaults";
import DateFormated from "../../../../Utils/Date/Date";
import Spinner from "../../../../UI/Spinner";
import {toast} from "react-toastify";
// utils

const ManageCard = (props) => {
    const { cardData, subAccountType } = props;
    const { t, i18n } = useTranslation();

    const form = <ManageCardForm cardData={cardData} closeModal={props.closeModal} formSubmit={(submitData) => formSubmitHandler(submitData)} subAccountType={subAccountType}/>;

    const [ showTopButtons, setShowTopButtons ] = useState(true);
    const [ innerContent, setInnerContent ] = useState(form);

	const reloadCardSummaryHandler = () => {
		props.reloadCardSummary();
	}

    const resetContentHandler = () => {
        setShowTopButtons(true);
        setInnerContent(form);
        props.changeModalTitle(t('account.cards.management.modal_title'));
    }

    const blockCardButtonHandler = () => {
        setShowTopButtons(false);
        setInnerContent(<BlockCardPanel  cardDetails={cardData} closeModal={props.closeModal} cancelAction={resetContentHandler} reloadCardSummary={props.reloadCardSummary} />);
        props.changeModalTitle(t('account.cards.management.lock_card.modal_title'));
    }

    const replaceCardButtonHandler = async() => {
		setInnerContent(<Spinner/>)
        await axios.get(`/references/CreditCardReplacementReason`)
            .then(response => {
                if (response.data.succeeded) {
                    setShowTopButtons(false);
                    setInnerContent(<ReplaceCardPanel closeModal={props.closeModal} cancelAction={resetContentHandler} cardData={cardData} remplacementReasons={response.data.data} reloadCardSummary={props.reloadCardSummary}/>);
                    props.changeModalTitle(t('account.cards.management.replace_card.modal_title'));
                }
            }).catch(error => {
				toast.error(
					<div>
						<i className="fal fa-exclamation-circle"></i>&nbsp;{error.message }
					</div>
				);
				setInnerContent(<ReplaceCardPanel closeModal={props.closeModal(false)} cancelAction={resetContentHandler} cardData={cardData} remplacementReasons={response.data.data}/>);
                console.log('[ManageCard.js] : Invoices ajax error in replaceCardButtonHandler()', error.message);
            });
    }

    const formSubmitHandler = (submitData) => {
        setShowTopButtons(false);
        setInnerContent(<SaveCardPanel submitData={submitData} closeModal={props.closeModal} cancelAction={resetContentHandler} reloadCardSummary={props.reloadCardSummary} />);
        props.changeModalTitle(t('account.cards.management.confirm.modal_title'));
    }

    return (
        <div className="cardmanager">
            <div className="cardmanager__upper">
                <div className="cardmanager__upper__main">
                    <strong className="cardmanager__upper__subtitle">
                        {cardData.cardHolder}
                    </strong>
                    <h3 className="cardmanager__upper__title headline headline--main">
                        XXXX&nbsp;XXXX&nbsp;XXXX&nbsp;{cardData.cardNumber.slice(cardData.cardNumber.length - 4)}
                    </h3>
                </div>
                <div className="cardmanager__upper__meta">
                    <p className="cardmanager__upper__meta__item">
                        { t('account.cards.management.issuing_date') }:&nbsp;
                        {cardData.issueDate ? <span>{<DateFormated date={cardData.issueDate} withTime={false}/>}</span> : null}
                    </p>
                    <p className="cardmanager__upper__meta__item">
                        { t('account.cards.management.expiration_date') }:&nbsp;
                        {cardData.expirationDate ? <span>{<DateFormated date={cardData.expirationDate} withTime={false}/>}</span> : null}
                    </p>
                </div>
                {
                    showTopButtons === true && (
                        <div className="cardmanager__upper__actions">
                            <button className="btn btn--outline" onClick={blockCardButtonHandler}>
                                <span className="btn__text">{ t('account.cards.management.buttons.block') } </span>
                                <span className="btn__icon"><i className="fas fa-lock"></i></span>
                            </button>
                            <button className="btn btn--outline" onClick={replaceCardButtonHandler}>
                                <span className="btn__text">{ t('account.cards.management.buttons.replace') } </span>
                                <span className="btn__icon"><i className="fas fa-retweet"></i></span>
                            </button>
                        </div>
                    )
                }
            </div>
            { innerContent }
        </div>
    );
};

export default ManageCard;
